interface FilterOption {
  value: string;
  label: string;
  count?: number;
}

interface FilterGroupProps {
  label: string;
  options: FilterOption[];
  value: string;
  onChange: (value: string) => void;
}

export default function FilterGroup({ label, options, value, onChange }: FilterGroupProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-4 py-3 first:pt-0 last:pb-0">
      <span className="shrink-0 sm:w-20 pt-1.5 text-[13px] font-medium text-foreground-500">
        {label}
      </span>
      <div className="flex flex-wrap gap-2">
        {options.map((option) => {
          const active = option.value === value;
          return (
            <button
              key={option.value}
              type="button"
              onClick={() => onChange(option.value)}
              className={`inline-flex items-center gap-1.5 h-8 px-3 rounded-full text-[13px] transition-colors cursor-pointer whitespace-nowrap ${
                active
                  ? "bg-primary-500 text-background-50 font-medium"
                  : "bg-background-100 text-foreground-700 hover:bg-background-200"
              }`}
            >
              {option.label}
              {typeof option.count === "number" && (
                <span
                  className={`font-label text-[11px] ${
                    active ? "text-primary-100" : "text-foreground-400"
                  }`}
                >
                  {option.count}
                </span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}